import type { CFScene, HSIconPolygon, HSTitleSetting } from '@types';

type Settings = {
  featureScene: Pick<CFScene, 'animation'> | null;
  iconPolygon: Omit<Partial<HSIconPolygon>, 'points' | 'ath' | 'atv'> | null;
  titleSetting: HSTitleSetting | null;
};

export const hsRecentSettings: Settings = {
  featureScene: null,
  iconPolygon: null,
  titleSetting: null,
};
